export class ResponseDTO {
  message: string;
  isSuccessful: boolean;
  errors: string[];
  statusCode: number;
};